export const PRIMARY_USER_ROLES = [
    "DD_Enrolled"
] 
export const SECONDARY_USER_ROLES = [
    "DD_NewVehicleVMSExcludeCost",
]